import './style.css';
import { Map, View } from 'ol';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { Projection } from 'ol/proj';
import { Image as ImageLayer, Tile as TileLayer } from 'ol/layer'
import ImageWMS from 'ol/source/ImageWMS';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';
import { createXYZ } from 'ol/tilegrid';
import { defaults as defaultControls, Control } from "ol/control";
import { DragBox, Select } from 'ol/interaction.js';
import { platformModifierKeyOnly } from 'ol/events/condition.js';
import { ScaleLine } from 'ol/control.js';
import { saveAs } from 'file-saver';

const region = new Style({
  stroke: new Stroke({
    color: 'black',
    width: 1,
  }),
  fill: new Fill({
    color: 'rgba(211,211,211,0.3)',
  }),
});

var fileUrls = [];
var fileNames = [];

const fishnetStyle = function (feature) {
  const status = feature.get("status");

  // green, all DTM
  if (status === '3') {
    return new Style({
      stroke: new Stroke({
        color: 'rgba(0,255,0, 1.0)',
        width: 3
      })
    });
  }
  // Orange DSM and DTM mix
  if (status === '2') {
    return new Style({
      stroke: new Stroke({
        color: 'rgba(255, 165, 0, 1.0)',
        width: 2
      })
    });
  }
  // grey, no DTM
  if (status === '1') {
    return new Style({
      stroke: new Stroke({
        color: 'rgba(211, 211, 211, 1.0)',
        width: 1
      })
    });
  }

};

class RegionControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const element = document.createElement('div');
    element.innerHTML = 'Region: ';
    element.id = "regionname";
    super({
      element: element,
      target: options.target,
    });
  }
}


var projection = new Projection({
  code: 'EPSG:4258',
  units: 'degrees'
});

//var extent = [-24.54, 27.64, 41.4, 80.8];
var extent = [-31.5, 27.6, 45.1, 75.0];
//-31.5,27.6,45.1,75.0

// Das shape hat: -24.5399063789999730,27.6422386740000690 : 41.3903914720001751,80.7700869810001194

var fishnet = new VectorLayer({
  source: new VectorSource({
    format: new GeoJSON(),
    url: 'fishnet_4258.geojson'
  }),
  style: fishnetStyle
})

var mundialis = new ImageLayer({
  visible: false,
  source: new ImageWMS({
    url: 'https://ows.mundialis.de/services/service',
    params: {
      'LAYERS': 'OSM-WMS',
      'VERSION': '1.1.1'
    },
    attributions: '&copy; <a target="_blank" href="https://www.openstreetmap.org/copyright">OSM Contributors</a> - OSM-WMS by <a target="_blank" href="https://www.mundialis.de/">mundialis</a>,'
  })
});

class WmsControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    var wmsDiv = document.createElement("div");
    var wmsCheckbox = document.createElement("input");
    wmsCheckbox.type = "checkbox";
    wmsCheckbox.id = "wms";
    wmsCheckbox.style.cssText = "width: 15px; height: 15px; padding: 0; margin: 0; vertical-align: bottom; position: relative; top: -1px;";
    var objLabel = document.createElement("label");
    objLabel.style.cssText = "display: block; padding-left: 15px; text-indent: -15px;";
    objLabel.innerHTML = " OSM-WMS ";
    objLabel.htmlFor = wmsCheckbox.id;
    objLabel.appendChild(wmsCheckbox);
    wmsDiv.appendChild(objLabel);
    wmsDiv.className = "wmsDiv";
    wmsDiv.id = "wmsDiv";

    super({
      element: wmsDiv,
      target: options.target,
    });

    wmsDiv.addEventListener(
      "click",
      this.handleWmsCheckboxChange.bind(this),
      false
    );

  }
  handleWmsCheckboxChange() {
    const checked = document.getElementById('wms');
    if (checked.checked) {
      mundialis.setVisible(true);
    } else {
      mundialis.setVisible(false);
    }
  }
}


var maxZoomStates = 12;
if (window.location.host === 'localhost:5173') {
  maxZoomStates = 8;
}

// Prepare tile vector layers
var states_laea_sub_4258 = new VectorTileLayer({
  className: 'states_laea_sub_4258',
  visible: false,
  declutter: true,
  source: new VectorTileSource({
    attributions: 'Made with <a target="_blank" href="http://www.naturalearthdata.com/">Natural Earth</a>.',
    projection: 'EPSG:4258',
    extent: extent,
    format: new MVT({ defaultDataProjection: 'EPSG:4258' }),
    tileGrid: createXYZ({
      minZoom: 0,
      maxZoom: maxZoomStates,
      //     tileSize: 512,
      //tileSize: 256,
      //tileSize: 65.93,
      extent: extent
    }),
    // tilePixelRatio: 8,
    tilePixelRatio: 1,
    url: "v_states_4258/{z}/{x}/{y}.pbf",
  }),
  extent: extent,
  style: region
});

var countries_laea_sub_4258 = new VectorTileLayer({
  className: 'countries_laea_sub_4258',
  declutter: true,
  source: new VectorTileSource({
    attributions: 'Made with <a target="_blank" href="http://www.naturalearthdata.com/">Natural Earth</a>.',
    projection: 'EPSG:4258',
    extent: extent,
    format: new MVT({ defaultDataProjection: 'EPSG:4258' }),
    tileGrid: createXYZ({
      minZoom: 1,
      maxZoom: 6,
      //     tileSize: 512,
      //tileSize: 256,
      //tileSize: 65.93,
      extent: extent
    }),
    // tilePixelRatio: 8,
    tilePixelRatio: 1,
    url: "v_countries_4258/{z}/{x}/{y}.pbf",
  }),
  extent: extent,
  style: region
});

const map = new Map({
  target: 'map',
  controls: defaultControls().extend([
    new RegionControl(),
    new WmsControl(),
    new ScaleLine()

  ]),
  // layers: [states_laea_sub_4258, countries_laea_sub_4258, fishnet
  layers: [mundialis, states_laea_sub_4258, countries_laea_sub_4258, fishnet
    //  layers: [mundialis, countries_laea_sub_4258
  ],
  view: new View({
    extent: extent,
    projection: projection,
    center: [8, 50.95],
    zoom: 2
  })
});

map.getView().on('change:resolution', (event) => {
  console.log(map.getView().getZoom());
  let zoom = map.getView().getZoom();
  if (zoom > 6 && states_laea_sub_4258.getVisible() === false) {
    states_laea_sub_4258.setVisible(true);
    countries_laea_sub_4258.setVisible(false);
  }
  if (zoom <= 6 && states_laea_sub_4258.getVisible() === true) {
    states_laea_sub_4258.setVisible(false);
    countries_laea_sub_4258.setVisible(true);
  }


});


// MouseOver Selection
map.on('pointermove', function (event) {
  if (countries_laea_sub_4258.getVisible()) {
    countries_laea_sub_4258.getFeatures(event.pixel).then(function (features) {
      if (features.length > 0) {
        document.getElementById('regionname').innerHTML = 'Region: ' + features[0].properties_.NAME;
      }
    });
  } else {
    states_laea_sub_4258.getFeatures(event.pixel).then(function (features) {
      if (features.length > 0) {
        document.getElementById('regionname').innerHTML = 'Region: ' + features[0].properties_.name;
      }
    });
  }
});

// a DragBox interaction used to select features by drawing boxes
const dragBox = new DragBox({
  condition: platformModifierKeyOnly,
});

map.addInteraction(dragBox);

dragBox.on('boxend', function () {
  const boxExtent = dragBox.getGeometry().getExtent();

  var featureCount = 0;
  var features = [];
  fileUrls = [];
  fileNames = [];

  const keysSet = new Set();
  const boxFeatures = fishnet.getSource()
    .getFeaturesInExtent(boxExtent)
    .filter(
      (feature) => {
        //console.log(feature)
        featureCount++;
        const file = feature.get('file');
        const licenses = feature.get('licenses');

        let html = '';

        fileNames.push(file);
        const url = 'https://openmaps.online/eudem_download/eu_4258/' + file + '.zip'
        fileUrls.push(url);
        html = '<a href="' + url + '" title="' + file + '">' + file + '</a>';
        console.log(file + ' ' + url);

        features.push(html);
        let licenseA = licenses.split(',');
        for (let i = 0; i < licenseA.length; i++) {
          keysSet.add(licenseA[i]);
        }


      }

    );

  // headlines

  document.getElementById('h1_1').innerHTML = "OpenDemEurope - Download Geographic Tiles EPSG:4258";
  document.getElementById('h1_2').innerHTML = "1 arc-second resolution";

  // datasets
  document.getElementById('count').innerText = features.length;
  const selected = document.getElementById('selecteddatasets');
  selected.innerHTML = '';
  for (let i = 0; i < features.length; i++) {
    selected.innerHTML += features[i] + "<br>";
  }
  // licences
  document.getElementById('licenses').innerHTML = '';
  // Iterate through the Set and print messages
  keysSet.forEach((key) => {
    if (key === "1") {
      document.getElementById('licenses').innerHTML += "<p>- <i>Produced using Copernicus data and information funded by the European Union - EU-DEM layers.</i><p/>";
    }
    if (key === "2") {
      document.getElementById('licenses').innerHTML += "<p>- <i>Land NRW (2017) Data license Germany – attribution – version 2.0 (<a target=\"_blank\" href=\"https://www.govdata.de/dl-de/by-2-0\">www.govdata.de/dl-de/by-2.0</a>)</i><p/>";
    }
    if (key === "3") {
      document.getElementById('licenses').innerHTML += "<p>- <i>Agentschap voor Geografische Informatie Vlaanderen - CC0 1.0 Universal  (<a target=\"_blank\" href=\"https://creativecommons.org/publicdomain/zero/1.0/deed.en\">CC0 1.0</a>)</i><p/>";
    }
    if (key === "4") {
      document.getElementById('licenses').innerHTML += "<p>- <i>Actueel Hoogtebestand Nederland (AHN) - CC0 1.0 Universal  (<a target=\"_blank\" href=\"https://creativecommons.org/publicdomain/zero/1.0/deed.en\">CC0 1.0</a>)</i><p/>";
    }
    if (key === "5") {
      document.getElementById('licenses').innerHTML += "<p>- <i>Ministry of the environment and spatial planning, Slovenian environment agency (<a target=\"_blank\" href=\"https://www.arso.gov.si\">www.arso.gov.si</a>)</i><p/>";
    }
    if (key === "6") {
      document.getElementById('licenses').innerHTML += "<p>- <i>Geoland.at (2019) - CC BY 4.0 (<a target=\"_blank\" href=\"https://creativecommons.org/licenses/by/4.0/deed.en\">CC BY 4.0</a>)</i><p/>";
    }
    if (key === "7") {
      document.getElementById('licenses').innerHTML += "<p>- <i>GEOPORTALE NAZIONALE - AccessConstraints: Nessuno - None</i><p/>";
    }
  });



  var info = document.getElementById("info");
  info.style.display = 'block';
  var closer = document.getElementById("closeInfo");
  closer.style.display = 'block';




});

// close info
var closer = document.getElementById("closeInfo");
closer.onclick = function () {
  closer.style.display = 'none';
  document.getElementById("info").style.display = 'none';
};

document.getElementById("downloadbutton").addEventListener("click", function () {
  downloadFilesSequentially(0);
});

var popup;

document.getElementById("newWindow").addEventListener("click", function () {
  var divText = document.getElementById("info").outerHTML;
  divText = divText.replace('class="closeInfo"', 'style="display:none"');
  divText = divText.replace(' <p> <button id="downloadbutton" type="button">Download all files </button> May not work with all browsers and\n      settings.</p>\n    <p> <button id="newWindow" type="button">Open in a new window tab</button></p>\n', '');
  popup = window.open('', 'Download');
  var doc = popup.document;
  doc.open();
  doc.write(divText);
  doc.close();

});

// Download multiple files
function downloadFilesSequentially(index) {

  saveAs(fileUrls[index], fileNames[index]);

  if (index < fileUrls.length) {
    index++;
    downloadFilesSequentially(index)
  }
}
